export default [
  {
    path: "/modules/event/",
    redirect: "/modules/event",
    name: "EventPage",
    component: () => import("@/views/modules/event/Event.vue"),
    meta: {
      action: "ROLE_ATEND_CONSULTAR",
      resource: "ACL",
      pageTitle: "Eventos",
      breadcrumb: [
        {
          text: "Eventos",
        },
      ],
    },
    children: [
      {
        path: "event",
        name: "event",
        component: () => import("@/views/modules/event/grid/EventGrid.vue"),
        meta: {
          pageTitle: "Eventos",
          action: "ROLE_PROFISSIONAL",
          resource: "ACL",
          breadcrumb: [
            {
              text: "Módulo Eventos | Eventos",
            },
          ],
        },
      },
    ],
  },
];
